import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);
const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      redirect: { path: "/login" },
    },
    {
      path: "/home",
      component: (resolve) =>
        require(["../components/common/Home.vue"], resolve),
      meta: { requiresAuth: true },
      children: [
        {
          path: "/",
          component: (resolve) =>
            require(["../components/user/Info.vue"], resolve),
        },
        {
          path: "/user/info",
          component: (resolve) =>
            require(["../components/user/Info.vue"], resolve),
        },
        {
          path: "/party/special",
          component: (resolve) =>
            require(["../components/party/Special.vue"], resolve),
        },
        {
          path: "/party/djdt",
          component: (resolve) =>
            require(["../components/party/Djdt.vue"], resolve),
        },
        {
          path: "/party/dflz",
          component: (resolve) =>
            require(["../components/party/Dflz.vue"], resolve),
        },
        {
          path: "/party/qtjs",
          component: (resolve) =>
            require(["../components/party/Qtjs.vue"], resolve),
        },
        {
          path: "/party/tpxw",
          component: (resolve) =>
            require(["../components/party/Tpxw.vue"], resolve),
        },
        {
          path: "/party/sxyd",
          component: (resolve) =>
            require(["../components/party/Sxyd.vue"], resolve),
        },
        {
          path: "/news/tjxw",
          component: (resolve) =>
            require(["../components/news/Tjxw.vue"], resolve),
        },
        {
          path: "/news/bnyw",
          component: (resolve) =>
            require(["../components/news/Bnyw.vue"], resolve),
        },
        {
          path: "/news/zxyw",
          component: (resolve) =>
            require(["../components/news/Zxyw.vue"], resolve),
        },
        {
          path: "/news/hdxw",
          component: (resolve) =>
            require(["../components/news/Hdxw.vue"], resolve),
        },
        {
          path: "/cooperation/zdzx",
          component: (resolve) =>
            require(["../components/cooperation/Zdzx.vue"], resolve),
        },
        {
          path: "/cooperation/gjhz",
          component: (resolve) =>
            require(["../components/cooperation/Gjhz.vue"], resolve),
        },
        {
          path: "/cooperation/glgd",
          component: (resolve) =>
            require(["../components/cooperation/Glgd.vue"], resolve),
        },
        {
          path: "/cooperation/xmjs",
          component: (resolve) =>
            require(["../components/cooperation/Xmjs.vue"], resolve),
        },
        {
          path: "/cooperation/glgd",
          component: (resolve) =>
            require(["../components/cooperation/Glgd.vue"], resolve),
        },
        {
          path: "/cooperation/wjxz",
          component: (resolve) =>
            require(["../components/cooperation/Wjxz.vue"], resolve),
        },
        {
          path: "/cooperation/hjqd",
          component: (resolve) =>
            require(["../components/cooperation/Hjqd.vue"], resolve),
        },
        {
          path: "/organization/zxjj",
          component: (resolve) =>
            require(["../components/organization/Zxjj.vue"], resolve),
        },
        {
          path: "/organization/zxld",
          component: (resolve) =>
            require(["../components/organization/Zxld.vue"], resolve),
        },
        {
          path: "/organization/zzjg",
          component: (resolve) =>
            require(["../components/organization/Zzjg.vue"], resolve),
        },
        {
          path: "/organization/bmzz",
          component: (resolve) =>
            require(["../components/organization/Bmzz.vue"], resolve),
        },
        {
          path: "/organization/zzzs",
          component: (resolve) =>
            require(["../components/organization/Zzzs.vue"], resolve),
        },
        {
          path: "/activity/ggtz",
          component: (resolve) =>
            require(["../components/activity/Ggtz.vue"], resolve),
        },
        {
          path: "/activity/zyhd",
          component: (resolve) =>
            require(["../components/activity/Zyhd.vue"], resolve),
        },
        {
          path: "/personnel/jypx",
          component: (resolve) =>
            require(["../components/personnel/Jypx.vue"], resolve),
        },
        {
          path: "/personnel/rczp",
          component: (resolve) =>
            require(["../components/personnel/Rczp.vue"], resolve),
        },
        {
          path: "/journal/list",
          component: (resolve) =>
            require(["../components/journal/List.vue"], resolve),
        },
        {
          path: "/journal/imgs",
          component: (resolve) =>
            require(["../components/journal/Imgs.vue"], resolve),
        },
        //                         {
        //                               path: '/work/subs',
        //                               component: resolve => require(['../components/work/Subs.vue'], resolve)
        //                         },
        //                         {
        //                               path: '/work/info',
        //                               component: resolve => require(['../components/work/Info.vue'], resolve)
        //                         },
        //                         {
        //                               path: '/work/list',
        //                               component: resolve => require(['../components/work/List.vue'], resolve)
        //                         },
        {
          path: "/workInfo/list",
          component: (resolve) =>
            require(["../components/workInfo/List.vue"], resolve),
        },
        {
          path: "/links/list",
          component: (resolve) =>
            require(["../components/links/List.vue"], resolve),
        },
        {
          path: "/rbac/role",
          component: (resolve) =>
            require(["../components/rbac/Role.vue"], resolve),
        },
        {
          path: "/rbac/permission",
          component: (resolve) =>
            require(["../components/rbac/Permission.vue"], resolve),
        },
        {
          path: "/rbac/user",
          component: (resolve) =>
            require(["../components/rbac/User.vue"], resolve),
        },
        {
          path: "/contactus/contact",
          component: (resolve) =>
            require(["../components/contactus/Contact.vue"], resolve),
        },
        {
          path: "/copyright/copyright",
          component: (resolve) =>
            require(["../components/copyright/Copyright.vue"], resolve),
        },
        {
          path: "/multipleinfo/jlwt",
          component: (resolve) =>
            require(["../components/multipleinfo/Jlwt.vue"], resolve),
        },
        {
          path: "/multipleinfo/zlgl",
          component: (resolve) =>
            require(["../components/multipleinfo/Zlgl.vue"], resolve),
        },
        {
          path: "/files/list",
          component: (resolve) =>
            require(["../components/files/List.vue"], resolve),
        },
        {
          path: "/partybuilding/partybuilding",
          component: (resolve) =>
            require(["../components/partybuilding/Partybuilding.vue"], resolve),
        },
        {
          path: "/quickLink/notice",
          component: (resolve) =>
            require(["../components/quickLink/Notice.vue"], resolve),
        },
      ],
    },
    {
      path: "/login",
      component: (resolve) =>
        require(["../components/common/Login.vue"], resolve),
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    //这里判断用户是否登录，我例子中是验证本地存储是否有token
    if (!localStorage.ms_username) {
      next({
        path: "/login",
        query: { redirect: to.fullPath },
      });
    } else {
      next();
    }
  } else if (to.matched.length === 0) {
    //如果未匹配到路由
    from.name ? next({ name: from.name }) : next("/"); //如果上级也未匹配到路由则跳转登录页面，如果上级能匹配到则转上级路由
  } else {
    next(); // 确保一定要调用 next()
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js